<template>
	<div class="pannel4">
		<!-- 标题-->
		<NavTiltle :titleNav="title" :titleTextNav="titleText" />
		<!-- PC -->
		<div class="ig-big">
			<div class="ig-big-item" v-for="adv in techAdvances" :key="adv.id">
				<img :src="adv.path" alt="advimg" />
				<!-- 蒙版 -->
				<div class="back-mark"></div>
				<!-- 显示文字 -->
				<div class="text-dec">
					<span>{{ adv.name }}</span>
					<p v-for="(items, idx) in adv.nameList" :key="idx">
						<i class="icon-font"></i>
						{{ items }}
					</p>
				</div>
				<!-- 放大展示二维码 -->
				<div class="img-mark">
					<span>{{ adv.name }}</span>
					<div class="conent-img">
						<div class="conent-text">
							<p v-for="(items, idx) in adv.nameList"
					:key="idx">
					<i class="icon-font"></i>
					{{items}}
					</p>
						</div>
						<div class="img-right">
							<p v-if="adv.img?false:true">敬请<br>期待</p>
							<img :src="adv.img" alt="advimg" v-else></img>
							</div>
					</div>
          <div class="sys-text">
            <b v-if="adv.id==3||adv.id==5?true:false">[ 淘宝扫码立即体验黑科技 ]</b>
            <b v-else-if="adv.id==4?true:false">[ 微信扫码立即体验黑科技 ]</b>
            <b v-else>[ 扫码立即体验黑科技 ]</b>
          </div>
				</div>
			</div>
		</div>
		<!-- moblie -->
		<el-row class="gallery">
			<el-col
				v-for="(adv, idx) in techAdvances"
				:key="adv.id"
				@click.native="dec(idx)"
				:xs="idx != techAdvances.length - 1 ? 12 : 12"
				:sm="idx != techAdvances.length - 1 ? 12 : 12"
				:md="idx != techAdvances.length - 1 ? 4 : 4"
			>
				<div class="img-block">
          <el-image :src="adv.path" class="img">
          			   <div slot="placeholder" class="image-slot" style="{width: 50%;height: 298px;,background-color: #CCCCCC;}">
            <!-- 加载中<span class="dot">...</span> -->
          </div>
          </el-image>
           <!-- <el-image :src="adv.path" lazy class="img"></el-image> -->
					<!-- <img :src="adv.path" alt="advimg" /> -->
					<!-- 蒙版 -->
					<div class="back-mark" :class="idx == sci? 'show-mark' : 'back-mark'"></div>
					<!-- 显示文字 -->
					<div class="text-dec"  :style="{display:(idx == sci ?'none':'block') }">
						<span>{{ adv.name }}</span>
						<p v-for="(items, idx) in adv.nameList" :key="idx">
							<i class="icon-font"></i>
							{{ items }}
						</p>
					</div>
<div class="cick-text" :style="{display:(idx == sci ?'none':'block') }">[点击解锁黑科技]</div>
					<!-- 放大展示二维码 -->
					<div class="img-mark" v-if="idx == sci ? true : false">
						<span>{{ adv.name }}</span>
						<div class="conent-img">
							<div class="conent-text">
								<p v-for="(items, idx) in adv.nameList"
						:key="idx">
						<i class="icon-font"></i>
						{{items}}
						</p>
							</div>
							<div class="img-right">
                <p v-if="adv.img?false:true">敬请<br>期待</p>
								<img :src="adv.img" alt="advimg" v-else></img>
             <!-- <div class="sys-text">
				  <b v-if="adv.id==3||adv.id==5?true:false">[ 淘宝扫码立即体验黑科技 ]</b><b v-else>[ 扫码立即体验黑科技 ]</b>
              </div> -->
								</div>
						</div>
          <div class="sys-text">
          				  <!-- <b v-if="adv.id==3||adv.id==5?true:false">[ 淘宝扫码立即体验黑科技 ]</b><b v-else>[ 扫码立即体验黑科技 ]</b> -->
                    <b v-if="adv.id==3||adv.id==5?true:false">[ 淘宝扫码立即体验黑科技 ]</b>
                    <b v-else-if="adv.id==4?true:false">[ 微信扫码立即体验黑科技 ]</b>
                    <b v-else>[ 扫码立即体验黑科技 ]</b>
          </div>
					</div>

					<!-- -->
				</div>
			</el-col>
		</el-row>
		<!-- ipad pro -->
		<!--  -->
	</div>
</template>
<script>
import NavTiltle from "../components/NavTiltle.vue";
export default {
  name: "Pannel4",
  data() {
    return {
      sci: 0,
      title: "商业场景",
      titleText: "BUSINESS SCENE",
      techAdvances: [
        {
          name: "化妆品",
          // path: require('./../assets/images/商业场景/Meiye.png'),
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/Meiye.png",
          id: 1,
          nameList: ["护肤品", "仪器", "彩妆", "化妆工具"],
          img: require("./../assets/images/商业场景/skinV3.png"),
        },
        {
          name: "医美",
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/Medical.png",
          id: 2,
          nameList: ["医美机构", "医美平台", "美容美体"],
          img: require("./../assets/images/商业场景/blsmdj.png"),
        },
        {
          name: "健康",
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/healthy.png",
          id: 3,
          nameList: ["保健", "生鲜", "饮食", "减肥"],
          img: require("./../assets/images/商业场景/health.jpg"),
        },
        {
          name: "健身",
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/Bodybuilding.png",
          id: 4,
          nameList: ["健身课程", "健身器材", "减脂塑身"],
          img: require("./../assets/images/商业场景/bodytest.png"),
        },
        {
          name: "配饰",
          img: require("./../assets/images/商业场景/Accessoriesewm.png"),
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/Accessories.png",
          id: 5,
          nameList: ["眼镜", "美瞳", "珠宝", "饰品"],
        },
        {
          name: "服装",
          path:
            "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E5%95%86%E4%B8%9A%E5%9C%BA%E6%99%AF/clothing.png",
          id: 6,
          nameList: ["定制", "服装", "穿搭造型"],
        },
      ],
    };
  },
  components: {
    NavTiltle,
  },
  methods: {
    dec(ind) {
      this.sci = ind;
      console.log(this.techAdvances[ind].path, ind);
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.pannel4 {
  width: 100%;
  height: 100%;
  .gallery {
    display: none;
  }
  .ig-big {
    display: block;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-shrink: 0;
    .ig-big-item {
      width: 100%;
      overflow: hidden;
      height: 810px;
      position: relative;
      z-index: 9;
      .back-mark {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 99999;
        background: linear-gradient(
          180deg,
          rgba(167, 4, 71, 0.15) 1%,
          rgba(0, 0, 0, 0.7) 100%
        );
      }
      img {
        width: 100%;
        height: 810px;
        object-fit: cover;
      }
      &:hover {
        width: 150%;
        overflow: hidden;
        object-fit: cover;
        transition-duration: 0.5s;
        /*     以下三值为默认值，稍后会详细介绍 */
        transition-property: all;
        transition-timing-function: ease;
        transition-delay: 0s;
        .img-mark {
          display: block !important;
        }
        .back-mark {
          background: linear-gradient(
            180deg,
            rgba(232, 65, 66, 0) 0%,
            rgba(238, 0, 144, 0.17) 100%
          );
        }
        .text-dec {
          display: none;
        }
      }
      .text-dec {
        width: 200px;
        height: 200px;
        position: relative;
        transform: translate(-50%, -45%);
        top: -45%;
        left: 50%;
        display: block;
        z-index: 99999;
        span {
          display: inline-block;
          width: 100%;
          height: 36px;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 36px;
          letter-spacing: 10px;
          text-align: center;
        }
        p {
          margin-top: 30px;
          // width: 82px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
          position: relative;
          top: 33px;
          left: 50%;
          transform: translate(-50%, 0);
        }
        i {
          display: inline-block;
          width: 3px;
          height: 3px;
          background-color: #fff;
        }
      }
      .img-mark {
        display: none !important;
        // width: 430px;
        // width: 100%;
        height: 320px;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
        position: relative;
        transform: translate(-50%, -40%);
        top: -40%;
        left: 50%;
        display: flex;
        flex-direction: column;
        // padding: 0 32px;
        margin: 0 50px 0 0;
        .sys-text {
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translate(-50%, 0%);
          text-align: center;
          margin-top: 1.875rem;
          width: 100%;

          /* // height: 10px;
          width: 100%;
          text-align: center;
          // padding-bottom: 10px;
          margin-top: 30px; */
          b {
            font-size: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
        .conent-img {
          flex: 1;
          display: flex;
          justify-content: space-between;
          margin-top: 35px;
          box-sizing: border-box;
          padding: 0 30px;
          .conent-text {
            // flex: 1;
            height: 100%;
            p {
              width: 100%;
              height: 20px;
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333;
              line-height: 20px;
              position: relative;
              left: 50%;
              transform: translate(-50%, 0);
              margin-bottom: 12px;
            }
            i {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #e84142;
            }
          }
          .img-right {
            position: relative;
            width: 110px;
            height: 110px;
            img {
              width: 100%;
              height: 100%;
            }
            p {
              text-align: center;
            }
          }
        }
        span {
          margin-top: 23px;
          display: inline-block;
          width: 100%;
          height: 36px;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          line-height: 36px;
          letter-spacing: 10px;
          text-align: center;
          color: #333333;
        }
      }
    }
  }
}
@media only screen and (min-width: 1920px) {
  //大屏宽
  .el-col-md-4 {
    display: inline-block;
    width: 20%; // 重置宽度为 1/5
  }
  .pannel4 {
    width: 100%;
    height: 100%;
    .gallery {
      display: none;
    }
    .ig-big {
      display: block;
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      flex-shrink: 0;
      .ig-big-item {
        width: 100%;
        overflow: hidden;
        height: 810px;
        position: relative;
        z-index: 9;
        .back-mark {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 99999;
          background: linear-gradient(
            180deg,
            rgba(167, 4, 71, 0.15) 1%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        img {
          width: 100%;
          height: 810px;
          object-fit: cover;
        }
        &:hover {
          width: 150%;
          overflow: hidden;
          object-fit: cover;
          transition-duration: 0.5s;
          /*     以下三值为默认值，稍后会详细介绍 */
          transition-property: all;
          transition-timing-function: ease;
          transition-delay: 0s;
          .img-mark {
            display: block !important;
          }
          .back-mark {
            background: linear-gradient(
              180deg,
              rgba(232, 65, 66, 0) 0%,
              rgba(238, 0, 144, 0.17) 100%
            );
          }
          .text-dec {
            display: none;
          }
        }
        .text-dec {
          width: 143px;
          height: 200px;
          position: relative;
          transform: translate(-50%, -45%);
          top: -45%;
          left: 50%;
          display: block;
          z-index: 99999;
          span {
            display: inline-block;
            width: 100%;
            height: 36px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 36px;
            letter-spacing: 10px;
            text-align: center;
          }
          p {
            margin-top: 30px;
            width: 82px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
            position: relative;
            top: 33px;
            left: 50%;
            transform: translate(-50%, 0);
          }
          i {
            display: inline-block;
            width: 3px;
            height: 3px;
            background-color: #fff;
          }
        }
        .img-mark {
          display: none !important;
          // width: 430px;
          // width: 100%;
          height: 320px;
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
          position: relative;
          transform: translate(-50%, -40%);
          top: -40%;
          left: 50%;
          display: flex;
          flex-direction: column;
          // padding: 0 32px;
          margin: 0 50px 0 0;
          .sys-text {
            position: absolute;
            bottom: 10%;
            left: 50%;
            transform: translate(-50%, 0%);
            text-align: center;
            margin-top: 1.875rem;
            width: 100%;

            /* width: 100%;
          text-align: center;
          // padding-bottom: 10px;
           margin-top: 30px; */
            b {
              font-size: 8px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
          }
          .conent-img {
            flex: 1;
            display: flex;
            justify-content: space-between;
            margin-top: 35px;
            box-sizing: border-box;
            padding: 0 30px;
            .conent-text {
              // flex: 1;
              height: 100%;
              p {
                width: 100%;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333;
                line-height: 22px;
                position: relative;
                left: 50%;
                transform: translate(-50%, 0);
                margin-bottom: 16px;
              }
              i {
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #e84142;
              }
            }
            .img-right {
              position: relative;
              width: 110px;
              height: 110px;
              img {
                width: 100%;
                height: 100%;
              }
              p {
                text-align: center;
              }
            }
          }
          span {
            margin-top: 23px;
            display: inline-block;
            width: 100%;
            height: 36px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 36px;
            letter-spacing: 10px;
            text-align: center;
            color: #333333;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 769px) {
  .pannel4 {
    width: 100%;
    .gallery {
      display: block;
      .img-block {
        height: 100%;
        position: relative;
        .back-mark {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 999;
          background: linear-gradient(
            180deg,
            rgba(167, 4, 71, 0.15) 1%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        .show-mark {
          background: linear-gradient(
            180deg,
            rgba(232, 65, 66, 0) 0%,
            rgba(238, 0, 144, 0.17) 100%
          );
        }

        .img {
          width: 100%;
          height: 100%;
          display: block;
        }
        .cick-text {
          // width: 72px;
          font-size: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 11px;
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translate(-50%, -10%);
          // z-index: 9999;
          z-index: 999;
          display: block;
        }
        .text-dec {
          width: 140px;
          height: 104px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 999;

          span {
            display: inline-block;
            width: 100%;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            letter-spacing: 10px;
            text-align: center;
          }
          p {
            margin-top: 4px;
            width: 82px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
            position: relative;
            top: 12px;
            left: 50%;
            transform: translate(-50%, 0);
          }
          i {
            display: inline-block;
            width: 3px;
            height: 3px;
            background-color: #fff;
            margin-bottom: 2px;
          }
        }
        .img-mark {
          width: 163px;
          height: auto;
          box-sizing: border-box;
          padding: 0 0 10px 0;
          // height: 146px;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
          position: absolute;
          transform: translate(-50%, -31px);
          left: 50%;
          bottom: 0;
          display: flex;
          flex-direction: column;
          z-index: 999;
          .sys-text {
            height: 10px;
            width: 100%;
            text-align: center;
            // position: absolute;
            // bottom: 13%;
            // text-align: center;
            // box-sizing: border-box;
            padding-bottom: 10px;
            b {
              font-size: 8px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
          }
          .conent-img {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 10px;
            .conent-text {
              flex: 1;
              height: 100%;
              p {
                width: 100%;
                height: 11px;
                font-size: 8px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333;
                line-height: 11px;
                position: relative;
                left: 50%;
                transform: translate(-50%, 0);
                margin-bottom: 5px;
              }
              i {
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #e84142;
                margin-bottom: 2px;
              }
            }
            .img-right {
              width: 88px;
              height: 60px;
              position: relative;

              img {
                width: 50px;
                height: 50px;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
              }
              p {
                width: 53px;
                height: 64px;
                text-align: center;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
                font-size: 18px;
              }
            }
          }
          span {
            margin-top: 8px;
            display: inline-block;
            width: 100%;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: 5px;
            text-align: center;
            color: #333333;
            margin-bottom: 8px;
          }
          // .sys-text{
          //   width: 100%;
          //   // background-color: #001929;
          //   height: 7px;
          //   width: 100%;
          //   position: absolute;
          //   bottom: 10%;
          //   text-align: center;
          //       b{
          //   font-size: 5px;
          //   font-family: PingFangSC-Regular, PingFang SC;
          //   font-weight: 400;
          //   color: #333333;

          //       }

          // }
        }
      }
    }
    .ig-big {
      display: none;
    }
  }
}
@media screen and (min-width: 770px) and (max-width: 1024px) {
  //ipad pro
  .el-col-md-4 {
    display: inline-block;
    width: 50%; // 重置宽度为 1/5
  }
}
</style>
